import { BORDER_WIDTH } from "../form/input/constants";
import { getColor } from "../utils";
export var disabledStyles = function disabledStyles(_ref) {
  var error = _ref.error,
      disabled = _ref.disabled,
      selectors = _ref.selectors,
      warning = _ref.warning;
  return disabled ? {
    backgroundColor: selectors.color('neutral10'),
    cursor: 'not-allowed',
    color: selectors.color('neutral70'),
    WebkitTextFillColor: selectors.color('neutral70')
    /* Safari */
    ,
    opacity: 1,
    border: "".concat(BORDER_WIDTH, "px solid ").concat(selectors.color('neutral50'))
  } : {
    ':hover': {
      border: "".concat(BORDER_WIDTH, "px solid ").concat(getColor(selectors, 'primary60', error, warning))
    }
  };
};